/// <summary>
/// This object provides js functions for the Bluaul.VC.Widget.Admin.Search <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 13.8.2021<br />
/// Copyright ©: EUDT GmbH 2021 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 13.8.2021                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
$.widget("bluaul.ShareUrl", $.common.VisualBase, {
    key: "",
    _create: function () {
        var me = this;
        try {
         
            me.element.html("");
            // set the Visual-Name first
            me.options.invoke.vcvid = 321;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));
          
            //inits the super class
            me._super();
           
        } catch (e) {
            me.writeError('_create', e);
            return false;
        }
        return true;
    },

    _initHTML: function () {
        var me = this;
        try {

           // me.showMessage("", false);
        

        } catch (e) {
            me.writeError('_initHTML', e);
            return false;
        }
        return true;
    },

    _initEvents: function () {
        var me = this;
        try {
         
            me.key = me.specific.settings.Key;

           var htmlDt = me.element.find(".dt").clone();

           me.fnd(".dt").replaceWith(
               $("<div>", { "class": "dt-box box1 vc-grid-2col vc-grid-margin-right vc-grid-margin-bottom" })
           );
           me.fnd(".dt-box").vcOptionBox({
               caption: me.resources.selection,
               items: [{ button: me.specific.resources.datatype_lbl, clickable: false, isList: true, content: htmlDt.clone() }]
           });
           me.fnd(".ddl.dt").val(me.specific.settings.DeviceType);

           var htmlOptions = me.element.find("#div-options").clone();

           me.fnd("#div-options").replaceWith(
               $("<div>", { "class": "o-box box1 vc-grid-2col  " })
           );
            me.fnd(".o-box").vcOptionBox({
               caption: me.resources.selection,
                items: [{ button: me.specific.resources.options_lbl, clickable: false, isList: false, content: htmlOptions.clone() }]
           });
            me.fnd(".ddl.res").val(me.specific.settings.Info.Unit);

            var htmlDur = me.element.find(".dur").clone();

            me.fnd(".dur").replaceWith(
                $("<div>", { "class": "dur-box box1 vc-grid-2col vc-grid-margin-right vc-grid-margin-bottom" })
            );
            me.fnd(".dur-box").vcOptionBox({
                caption: me.resources.selection,
                items: [{ button: me.specific.resources.duration_lbl, clickable: false, isList: true, content: htmlDur.clone() }]
            });

            me.fnd(".ddl.dur").val(me.specific.settings.Duration);
          
            me.fnd("#txt-description").val(me.specific.settings.Info.Description);

            me.element.on("click", "#btn-generate", function () {
                me._askGenerate();
            });
            me.fnd("#btn-export").button();


        } catch (e) {
            me.writeError('_initEvents', e);
            return false;
        }
        return true;
    },


    _askGenerate: function () {
        /// <summary>
        /// This function fetches existing entries
        /// </summary>
        var me = this;
        try {

            var duration = parseInt(me.fnd(".dur").val());
            var deviceType = parseInt(me.fnd(".dt").val());

            if (duration == -1 && deviceType == 1) {
                me.openAskDialog(me.specific.resources.generateLinkWithNoDurationLimit_lbl, { at: 'center center-20%', of: window }, function () { me._generate(); });

            } else {
                me._generate();
            }

            return true;
          
        } catch (e) { me.writeError('_askGenerate', e); return false; }
        return true;
    },

    _generate: function () {
        /// <summary>
        /// This function fetches existing entries
        /// </summary>
        var me = this;
        try {
        

            var settings = me.specific.settings;


            me.fnd("#txt-height, #txt-width").removeClass("error");
            settings.Info.Width = me.fnd("#txt-width").val();
            if (!$.isNumeric(settings.Info.Width)) {
                me.fnd("#txt-width").addClass("error");
                return false;
            }
            settings.Info.Width = parseInt(settings.Info.Width);

            settings.Info.Height = me.fnd("#txt-height").val();
            if (!$.isNumeric(settings.Info.Height)) {
                me.fnd("#txt-height").addClass("error");
                return false;
            }
            settings.Info.Height = parseInt(settings.Info.Height);
            settings.Info.Unit = me.fnd(".res").val();
          
            settings.Duration = parseInt(me.fnd(".dur").val());
            settings.DeviceType = parseInt(me.fnd(".dt").val());

            settings.Info.Name = me.fnd("#txt-name").val();
            settings.Info.Description = me.fnd("#txt-description").val();


            window.VisualCoreService.getData(me.options.invoke.vcvid, me.vcgid, me.getCurrentTimestamp(), 0, 0, "", "", me.settings.deviceType, me.settings.langID, JSON.stringify(settings), function (result) {
                //check response content
               if (result == null) {
                   me.showMessage(me.resources.err_loadData, true);
                   return true;
                }
               if (result.Valid === false) {
                   me.fnd("#txt-url").html(result.ErrorMsg).addClass("error");
                   return true;
                }

                me.key = result.Key;
                me.specific.settings.Key = result.Key;
                me.fnd("#txt-url").removeClass("error").html(result.Url);
                me.fnd("#txt-url-iframe").removeClass("error").html(result.UrlIframe);

                me.fnd("#txt-url").select();
                document.execCommand("copy");
                me.fnd("#div-status").html(me.specific.resources.linkCopiedToClipboard).show();
                me.fnd("#div-status").fadeOut(4000, function () {
                    me.fnd("#div-status").html("");
                });
                return true;
            });

        } catch (e) { me.writeError('generate', e); return false;}
        return true;
    },

    copyToClipboard: function(text) {
        var $temp = $("<textarea>").attr("id", "myID").html(text);
        $("body").append($temp);
        $temp.select();
       
        document.execCommand("copy");
       // $temp.remove();
    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            //if (bError) {
            //    me.fnd(".lst-entries, #div-top-menu, #div-filter-menu").hide();
            //}
            return true;
        } catch (e) {
            me.writeError('_setDirty', e); return false;
        }
    }


});

